// Brokerage / Sub-Broker PR-6b — the brokerage firm's self-serve Stripe payout
// onboarding surface (the "Payment setup" tab). Reads its single Connect payout
// account's live status and generates a FRESH Stripe-hosted onboarding link on
// demand (robust against link expiry). The portal is import-isolated and CANNOT
// reach the staff types, so the wire shapes are mirrored LOCALLY here. No React
// Query in the portal — the tab reads with useState and re-runs the loader after
// a mutation.

import { portalApi } from "./client";

/** The firm's live payout-account onboarding status. `status` is a string:
 *  "NotStarted" (no account yet) | "Pending" | "Active" | "Restricted" |
 *  "Disabled". `onboardingComplete` is true once the account reaches Active. */
export interface BrokerageConnectStatus {
  brokerageId: string;
  onboardingComplete: boolean;
  onboardingCompletedAt: string | null;
  stripeAccountId: string | null;
  status: string;
  capabilitiesJson: string | null;
  onboardedAt: string | null;
}

/** The result of generating an onboarding link — the Stripe account id, derived
 *  status, and the Stripe-hosted link (null once Active). */
export interface BrokerageConnectAccountProvision {
  stripeAccountId: string;
  /** "Pending" | "Active" | "Restricted" | "Disabled". */
  status: string;
  onboardingUrl: string | null;
  onboardingUrlExpiresAt: string | null;
}

export const brokerageStripeApi = {
  /** The firm's live payout-account onboarding status (re-fetched from Stripe). */
  getStatus: () => portalApi.get<BrokerageConnectStatus>("/brokerage/stripe/status"),
  /** Provision (idempotent) and generate a fresh Stripe-hosted onboarding link. */
  onboardingLink: () =>
    portalApi.post<BrokerageConnectAccountProvision>("/brokerage/stripe/onboarding-link"),
};
